import {
    GET_METER_READINGS,
    GET_METER_READING_DETAILS,
    GET_LAST_METER_READING,
    CREATE_METER_READING,
    CREATE_BULK_METER_READINGS,
    UPLOAD_METER_READINGS,
    DOWNLOAD_METER_READING_TEMPLATE,
    UPDATE_METER_READING,
    DELETE_METER_READING,
    CLEAR_METER_READING_STATE
} from '../../index.types';

// Get All Meter Readings
export const getMeterReadings = (data) => ({
    type: GET_METER_READINGS,
    data
});

// Get Meter Reading Details
export const getMeterReadingDetails = (data) => ({
    type: GET_METER_READING_DETAILS,
    data
});

// Get Last Meter Reading for a flat/head
export const getLastMeterReading = (data) => ({
    type: GET_LAST_METER_READING,
    data
});

// Create Meter Reading
export const createMeterReading = (data) => ({
    type: CREATE_METER_READING,
    data
});

// Bulk Create Meter Readings
export const createBulkMeterReadings = (data) => ({
    type: CREATE_BULK_METER_READINGS,
    data
});

// Upload Meter Readings via Excel
export const uploadMeterReadings = (data) => ({
    type: UPLOAD_METER_READINGS,
    data
});

// Download Meter Reading Template
export const downloadMeterReadingTemplate = (data) => ({
    type: DOWNLOAD_METER_READING_TEMPLATE,
    data
});

// Update Meter Reading
export const updateMeterReading = (data) => ({
    type: UPDATE_METER_READING,
    data
});

// Delete Meter Reading
export const deleteMeterReading = (data) => ({
    type: DELETE_METER_READING,
    data
});

// Clear Meter Reading State
export const clearMeterReadingState = () => ({
    type: CLEAR_METER_READING_STATE
});
